import Image from 'next/image';

import { IImageType } from '@/src/types';

type IProps = {
  image: IImageType | null;
};

export const CustomComponentImage = ({ image }: IProps) => {
  return (
    <>
      {image && (
        <Image
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          src={image.image}
          alt={image.alt || ''}
          width={1130}
          height={690}
        />
      )}
    </>
  );
};
